<template>
	<v-app-bar
			ref="topNav"
			:class="[$vuetify.breakpoint.smAndUp && 'px-4']"
			elevation="0"
			fixed
			:style="topNavStyle"
	>
		<!-- SideNav Opener -->
		<!-- This element must be hidden with v-show and not v-if directive -->
		<v-app-bar-nav-icon
				v-if="
        sideNavState.temporary &&
        !(templateSettings && templateSettings.HomeButton)
      "
				class="ms-n2 me-2"
				dark
				style="height: 38px; width: 38px"
				@click="toggleSideNav"
		>
			<template v-slot:default>
				<v-icon>mdi-view-headline</v-icon>
			</template>
		</v-app-bar-nav-icon>
		<!-- End SideNav Opener -->
		<v-btn
				v-if="
        $vuetify.breakpoint.xs ||
        (templateSettings && templateSettings.HomeButton)
      "
				class="me-2 ms-n1"
				:href="
        templateSettings && templateSettings.HomeButton
          ? templateSettings.HomeButton
          : selectedPartner.id === 0
          ? '/superAdmin'
          : `/admin/${selectedPartner.id}`
      "
				style="padding: 0; min-width: auto"
				text
		>
			<div class="top-nav-logo"></div>
		</v-btn>

		<!-- Search Partner -->
		<div class="flex-grow-1">
			<v-autocomplete
					v-if="shouldShowPartnerSelect"
					:key="selectedPartnerKey"
					ref="partnerSelect"
					v-model="currentSelectedPartner"
					:background-color="
						partnerSelectFocused ? 'white' : 'rgba(255,255,255,0.1)'
					"
					class="elevation-0 partner-select"
					:clearable="$vuetify.breakpoint.smAndUp"
					:color="partnerSelectFocused ? 'black' : 'rgba(255,255,255,0.7)'"
					dark
					data-form-type="other"
					:data-lpignore="true"
					dense
					:filter="idNameSearchFunc"
					hide-details
					item-value="id"
					:items="partnerSelectItems"
					outlined
					@blur="() => (this.partnerSelectFocused = false)"
					@change="partnerChanged"
					@focus="() => (this.partnerSelectFocused = true)"
			>
				<template v-slot:selection="{ item }">
          <span
							class="opacity-80"
							:class="{
              'text-caption': $vuetify.breakpoint.xs,
              'text-body-2': $vuetify.breakpoint.sm,
              'white--text': !partnerSelectFocused,
              'black--text': partnerSelectFocused
            }"
					>
            {{ item.id }} - {{ item.name }}
          </span>
				</template>
				<template v-slot:item="{ item }">
          <span
							:class="{
              'text-caption': $vuetify.breakpoint.xs,
              'text-body-2': $vuetify.breakpoint.sm
            }"
					>
            {{ item.id }} - {{ item.name }}
          </span>
				</template>
			</v-autocomplete>
			<v-autocomplete
				v-if="shouldShowVenueSelect"
				:key="selectedVenueKey"
				ref="partnerSelect"
				v-model="currentSelectedVenue"
				:background-color="
						venueSelectFocused ? 'white' : 'rgba(255,255,255,0.1)'
					"
				class="elevation-0 partner-select"
				:clearable="$vuetify.breakpoint.smAndUp"
				:color="venueSelectFocused ? 'black' : 'rgba(255,255,255,0.7)'"
				dark
				data-form-type="other"
				:data-lpignore="true"
				dense
				:filter="idNameSearchFunc"
				hide-details	
				item-value="id"
				:items="userVenues"
				outlined
				@blur="() => (this.venueSelectFocused = false)"
				@change="venueChanged"
				@focus="() => (this.venueSelectFocused = true)"
			>
				<template v-slot:selection="{ item }">
          <span
			  class="opacity-80"
			  :class="{
              'text-caption': $vuetify.breakpoint.xs,
              'text-body-2': $vuetify.breakpoint.sm,
              'white--text': !venueSelectFocused,
              'black--text': venueSelectFocused
            }"
		  >
            {{ item.id }} - {{ item.name }}
          </span>
				</template>
				<template v-slot:item="{ item }">
          <span
			  :class="{
              'text-caption': $vuetify.breakpoint.xs,
              'text-body-2': $vuetify.breakpoint.sm
            }"
		  >
            {{ item.id }} - {{ item.name }}
          </span>
				</template>
			</v-autocomplete>
		</div>

		<div v-if="!shouldShowPartnerSelect" class="flex-grow-1">
			<input type="hidden" :value="partner.id"/>
		</div>

		<!-- Search Form (visible on larger screens) -->
		<div
				v-if="shouldShowOrderSearch && $vuetify.breakpoint.mdAndUp"
				class="flex-grow-0 ms-1"
		>
			<v-text-field
					id="search-order"
					v-model="search.orders"
					:background-color="
						orderSearchFocused ? 'white' : 'rgba(255,255,255,0.1)'
					"
					class="elevation-0 search-order"
					dense
					hide-details
					key="order-search-key"
					name="page-header-search-input2"
					outlined
					placeholder="Search Orders"
					@blur="orderSearchFocused = false"
					@click:append="goToOrder"
					@focus="orderSearchFocused = true"
					@keydown.enter="goToOrder"
			>
				<template v-slot:append>
					<v-icon
							:class="{
              'white--text': !orderSearchFocused,
              'black--text': orderSearchFocused
            }"
					>
						mdi-magnify
					</v-icon>
				</template>
			</v-text-field>
		</div>

		<v-spacer
				v-if="
        $vuetify.breakpoint.smAndUp &&
        !(templateSettings && templateSettings.HomeButton)
      "
				class="flex-grow-0 mx-2 ms-sm-4 mx-lg-8 mx-xl-16"
		></v-spacer>

		<!-- PRIVATE MESSAGES -->
		<div v-if="shouldShowPrivateMessages && myUser.id && privateMessageLink && $vuetify.breakpoint.smAndUp" class="flex-md-grow-0">
			<v-btn
					class="icon-only px-2 white"
					:href="privateMessageLink"
					style="min-width: 40px"
					text
			>
				<v-icon v-if="unreadMessageCount === 0">mdi-email-outline</v-icon>
				<v-icon v-if="unreadMessageCount > 0">mdi-email-open-outline</v-icon>
				<v-badge
						v-if="unreadMessageCount > 0"
						class="ms-n5 me-n2 mt-n2"
						:content="unreadMessageCount"
						inline
						:value="unreadMessageCount"
				></v-badge>
			</v-btn>
		</div>

		<!-- MY ACCOUNT -->
		<div v-if="myUser.id" class="flex-md-grow-0 mx-2">
			<v-menu
					v-model="accountMenu"
					:close-on-content-click="false"
					:nudge-width="200"
					offset-x
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
							v-bind="attrs"
							class="white"
							:style="$vuetify.breakpoint.xs && 'min-width: 40px; padding: 0;'"
							text
							v-on="on"
					>
            <span v-if="$vuetify.breakpoint.xs">
              {{ getInitials() }}
            </span>
						<span v-if="$vuetify.breakpoint.smOnly">
              {{ myUser.first_name || getFirstName() }}
            </span>
						<span v-if="$vuetify.breakpoint.mdAndUp">
              {{ `${getFirstName().charAt(0)}. ${getLastName()}` }}
            </span>
					</v-btn>
				</template>

				<v-card>
					<v-list>
						<v-list-item>
							<v-list-item-avatar>
								<img :alt="myUser.name" :src="myUser.avatar"/>
							</v-list-item-avatar>

							<v-list-item-content>
								<v-list-item-title>{{ myUser.name }}</v-list-item-title>
								<v-list-item-subtitle>{{ myUser.email }}</v-list-item-subtitle>
							</v-list-item-content>

							<v-list-item-action>
								<v-btn icon>
									<v-icon>mdi-account-outline</v-icon>
								</v-btn>
							</v-list-item-action>
						</v-list-item>
					</v-list>

					<v-divider></v-divider>

					<v-list>
						<v-list-item
								v-if="privateMessageLink && $vuetify.breakpoint.xs"
								:href="privateMessageLink"
						>
							<v-list-item-title>Private Messages</v-list-item-title>
							<v-list-item-action>
								<v-icon v-if="unreadMessageCount === 0">
									mdi-email-outline
								</v-icon>
								<v-icon v-if="unreadMessageCount > 0">
									mdi-email-open-outline
								</v-icon>
								<v-badge
										v-if="unreadMessageCount > 0"
										class="ms-n5 me-n2 mt-n2"
										:content="unreadMessageCount"
										inline
										:value="unreadMessageCount"
								></v-badge>
							</v-list-item-action>
						</v-list-item>

						<v-list-item href="/forgot-password">
							<v-list-item-title>Update Password</v-list-item-title>
							<v-list-item-action>
								<v-icon>mdi-form-textbox-password</v-icon>
							</v-list-item-action>
						</v-list-item>

						<v-list-item href="/users/mfa" v-if="$bwFeatures.mfa">
							<v-list-item-title>
								Configure Two-factor {{
									$vuetify.breakpoint.xsOnly
											? 'Auth'
											: 'Authentication'
								}}
							</v-list-item-title>
							<v-list-item-action>
								<v-icon>mdi-two-factor-authentication</v-icon>
							</v-list-item-action>
						</v-list-item>

						<v-list-item @click="submitLogout">
							<v-list-item-title>Sign Out</v-list-item-title>
							<v-list-item-action>
								<v-icon>mdi-logout-variant</v-icon>
							</v-list-item-action>
							<form
									id="logout-form"
									action="/logout"
									method="POST"
									style="display: none"
							>
								<input type="hidden" :value="csrfToken"/>
							</form>
						</v-list-item>
					</v-list>
				</v-card>
			</v-menu>
		</div>

		<!-- PENDING ACTIONS -->
		<template v-if="pendingActions.length && $vuetify.breakpoint.smAndUp">
			<v-menu
					v-model="pendingActionsMenu"
					:close-on-content-click="false"
					max-height="95vh"
					:nudge-width="200"
					offset-x
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
							v-bind="attrs"
							class="icon-only px-2 white"
							:style="`min-width: 40px; ${
              $vuetify.breakpoint.xs && 'padding: 0;'
            }`"
							text
							v-on="on"
					>
						<v-icon>mdi-bell-outline</v-icon>
						<v-badge
								v-if="pendingActions.length > 0"
								class="ms-n5 me-n2 mt-n2"
								:content="pendingActions.length"
								inline
								:value="pendingActions.length"
						></v-badge>
					</v-btn>
				</template>
				<v-card>
					<v-list v-if="pendingActions.length" dense>
						<template v-for="(pendingAction, idx) in pendingActions">
							<div>
								<v-list-item :key="idx" :href="pendingAction.link">
									<v-list-item-content>
										<v-list-item-title>
											{{ pendingAction.title }}
										</v-list-item-title>
										<v-list-item-subtitle>
											{{ pendingAction.subtitle }}
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-icon style="opacity: 0.3">
											mdi-chevron-right-circle
										</v-icon>
									</v-list-item-action>
								</v-list-item>
								<v-divider
										v-if="idx < pendingActions.length"
										class="my-0"
								></v-divider>
							</div>
						</template>
					</v-list>
				</v-card>
			</v-menu>
		</template>

		<!-- CALL TALLY -->
		<template v-if="templateSettings && templateSettings.showCallTally">
			<div class="call-tally d-flex ms-2 ms-md-4 blue px-2 rounded white--text">
				<v-icon dark size="20">mdi-phone-outline</v-icon>
				<v-badge
						id="callTally"
						class="font-weight-bold me-n1 ms-n1"
						color="rgba(0, 0, 0, 0.2)"
						content="0"
						inline
						style="margin-top: 6px"
				></v-badge>
			</div>
		</template>
	</v-app-bar>
</template>

<script>
export default {
	name: 'TopNav',
	props: {
		bwPartnerAccess: {
			type: [Boolean, String]
		},
		myUser: {
			type: Object,
			default: () => {
			}
		},
		partner: {
			type: Object,
			default: () => {
			}
		},
		pendingActions: {
			type: Array,
			default: () => []
		},
		portal: {
			type: String,
			default: 'admin'
		},
		selectedPartner: {
			type: Object,
			default: () => {
			}
		},
		selectedVenue: {
			type: Object,
			default: () => {
			}
		},
		templateSettings: {
			type: Object,
			default: () => {
			}
		},
		userPartners: {
			type: Array,
			default: () => []
		},
		userVenues: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			accountMenu: false,
			currentSelectedPartner: this.selectedPartner,
			currentSelectedVenue: this.selectedVenue,
			hasSecondaryMenu: false,
			orderSearchFocused: false,
			partnerSelectFocused: false,
			pendingActionsMenu: false,
			privateMessageLink: this.partner.id
					? `/admin/${this.partner.id}/privateMessages`
					: this.myUser.is_admin
					? '/superAdmin/privateMessages'
          : false
      ,
			search: {
				orders: ''
			},
			venueSelectFocused: false,
		};
	},
	computed: {
		breakpoint() {
			return this.$vuetify.breakpoint.name;
		},
		csrfToken() {
			return document.querySelector('meta[name="csrf-token"]').content;
		},
		hasSideNav() {
			return !this.templateSettings?.hideSideNav;
		},
		mainContentEl() {
			return document.getElementById('main-content');
		},
		partnerSelectItems() {
			return this.bwPartnerAccess
					? [{ id: 0, name: 'Bandwango (Super Admin)' }, ...this.userPartners]
					: [...this.userPartners];
		},
		selectedPartnerKey() {
			return `partner-${this.selectedPartner?.id || 0}`;
		},
		selectedVenueKey() {
			return `venue-${this.selectedVenue?.id || 0}`;
		},
		shouldShowOrderSearch() {
			return (!this.templateSettings || !this.templateSettings?.hideSearchForm)
					&& !window.location.pathname.includes('partner-portal')
					&& !window.location.pathname.includes('merchant-portal');
		},
		shouldShowPrivateMessages() {
			return (!this.templateSettings || !this.templateSettings?.hidePrivateMessages)
					&& !window.location.pathname.includes('partner-portal');
		},
		shouldShowPartnerSelect() {
			return (
					!window.location.pathname.includes('merchant-portal') &&
					this.userPartners.length &&
					(!this.templateSettings || !this.templateSettings?.hidePartnerSelect)
			);
		},
		shouldShowVenueSelect() {
			return (
				window.location.pathname.includes('merchant-portal') && 
				this.userVenues?.length > 1 &&
				(!this.templateSettings || !this.templateSettings?.hideVenueSelect)
				
			);
		},
		sideNavEl() {
			return document.getElementById('side-nav');
		},
		sideNavState() {
			return {
				hover:
						this.$vuetify.breakpoint.smOnly ||
						this.$vuetify.breakpoint.mdOnly ||
						(!this.$vuetify.breakpoint.xs && this.hasSecondaryMenu),
				temporary: this.$vuetify.breakpoint.xs,
				permanent: this.$vuetify.breakpoint.smAndUp
			};
		},
		topNavStyle() {
			if(!this.hasSideNav) return { left: 0 };
			if(this.sideNavState.permanent && !this.sideNavState.hover)
				return { left: '256px' };
			if(this.sideNavState.hover) return { left: '56px' };
			return { left: 0 };
		},
		unreadMessageCount() {
			// return 5;
			return this.myUser?.unreadMessages || 0;
		}
	},
	methods: {
		getInitials() {
			const firstInitial = this.myUser.first_name
					? this.myUser.first_name.charAt(0).toUpperCase()
					: this.myUser.name.charAt(0).toUpperCase();
			const lastInitial = this.myUser.last_name
					? this.myUser.last_name.charAt(0).toUpperCase()
					: this.myUser.name.split(' ')[1].charAt(0).toUpperCase();
			return `${firstInitial}${lastInitial}`;
		},
		getFirstName() {
			return this.myUser.first_name || this.myUser.name.split(' ')[0];
		},
		getLastName() {
			return (
					this.myUser.last_name ||
					this.myUser.name
							.split(' ')
							.map((n, i) => {
								if(i > 0) return n;
							})
							.join(' ')
			);
		},
		goToOrder() {
			if(this.search.orders.length)
				if(this.partner.id) {
					window.location.href = `/admin/${this.partner.id}/reports/orders?type=id&search=${this.search.orders}`;
				}
				else {
					window.location.href = `/superAdmin/reports/orders?type=id&search=${this.search.orders}`;
				}

		},

		onClassChange(classAttrValue) {
			const classList = classAttrValue.split(' ');
			this.hasSecondaryMenu = classList.includes('has-secondary-nav');
		},

		partnerChanged(partnerId) {
			if(partnerId === null) return false;

			if( this.portal == 'partner' ) {
				window.location = `/partner-portal/${partnerId}`;
			}else{
				window.location = partnerId === 0 ? '/superAdmin' : `/admin/${partnerId}`;
			}
		},

		venueChanged(venueId) {
			if(venueId === null) return false;
			window.location = `/merchant-portal/${venueId}/dashboard/main/view-dashboard`;
		},

		idNameSearchFunc(item, queryText) {
			const itemText = `${item.id} - ${item.name}`;
			return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
		},

		submitLogout() {
			document.getElementById('logout-form').submit();
		},

		toggleSideNav() {
			document.body.classList.toggle('side-nav--open');
		}
	},
	beforeCreate() {
		document.body.classList.add(`breakpoint-${this.$vuetify.breakpoint.name}`);
	},
	mounted() {
		this.observer = new MutationObserver(mutations => {
			mutations.forEach(m => {
				const newValue = m.target.getAttribute(m.attributeName);
				this.$nextTick(() => {
					this.onClassChange(newValue, m.oldValue);
				});
			});
		});

		this.observer.observe(document.body, {
			attributes: true,
			attributeOldValue: true,
			attributeFilter: ['class']
		});
	},
	watch: {
		breakpoint: {
			handler(newValue, oldValue) {
				document.body.classList.remove(`breakpoint-${oldValue}`);
				document.body.classList.add(`breakpoint-${newValue}`);
			}
		}
	},
	vuetify: window.Vuetify
};

// v-input elevation-0 partner-select v-input--hide-details v-input--is-label-active v-input--is-dirty v-input--is-focused v-input--dense theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select v-select--is-menu-active v-autocomplete
</script>

<style lang="scss">
#top-nav {
	background-color: #2e2e2e;
	transition: left 300ms ease-in-out;
}

body.hide-side-nav #top-nav {
	left: 0 !important;
}

.v-text-field--outlined.v-input--dense {
	&.v-text-field--outlined {
		& > .v-input__control {
			& > .v-input__slot {
				min-height: 38px;
			}
		}
	}
}

.v-select.v-text-field--outlined:not(.v-text-field--single-line) {
	&.v-input--dense .v-select__selections {
		padding: 3px 0;
	}
}

.top-nav-logo {
	background-image: url('/images/logo_bw_white.svg');
	background-position: right center;
	background-size: cover;
	height: 40px;
	transition: width 300ms ease-in-out;
	min-width: 132px;
}

body.breakpoint-xs:not(.hide-side-nav) .top-nav-logo,
body.breakpoint-sm:not(.hide-side-nav) .top-nav-logo,
body.breakpoint-md:not(.hide-side-nav) .top-nav-logo {
	min-width: 25px;
}

.call-tally {
	/*background-color: rgba(130, 186, 12, 0.7);*/
	height: 38px;
}

.partner-select,
.search-order {
	& fieldset {
		border: solid 1px rgba(255, 255, 255, 0.1) !important;
	}
}

.search-order {
	& input {
		color: white !important;

		&::placeholder {
			color: rgba(255, 255, 255, 0.5) !important;
		}
	}

	&.v-input--is-focused input {
		color: black !important;

		&::placeholder {
			color: rgba(0, 0, 0, 0.7) !important;
		}
	}
}

#top-nav .v-autocomplete {
	& input {
		color: white !important;
		opacity: 0.8;

		@media (max-width: 599px) {
			font-size: 0.75rem !important;
		}

		@media (max-width: 959px) {
			font-size: 0.875rem !important;
		}
	}

	&.black--text input {
		color: black !important;
	}
}
</style>
